import { updates } from '@/mocks/homeData';

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-16 md:py-20 bg-background-100/70">
      <div className="max-w-[900px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            实时快讯
          </h2>
          <p className="mt-2 text-sm text-foreground-500">
            滚动更新，不错过任何一个新瓜
          </p>
        </div>

        <div className="relative pl-8">
          <div className="absolute left-[11px] top-1 bottom-1 w-0.5 bg-background-300/80"></div>

          <div className="space-y-5">
            {updates.map((item, idx) => (
              <div key={idx} className="relative group cursor-pointer">
                <div className={`absolute -left-[31px] top-1.5 w-3 h-3 rounded-full border-2 ${
                  idx === 0
                    ? 'bg-accent-500 border-accent-500'
                    : idx === 1
                    ? 'bg-primary-500 border-primary-500'
                    : 'bg-background-200 border-background-300'
                }`}></div>

                <div className="p-4 rounded-xl bg-background-50 border border-background-200/70 hover:border-accent-300/60 transition-all duration-200">
                  <div className="flex items-center gap-3 mb-2">
                    <span className={`text-xs font-semibold whitespace-nowrap ${
                      idx < 2 ? 'text-accent-600' : 'text-foreground-400'
                    }`}>
                      {item.time}
                    </span>
                    <span className="text-xs px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 font-medium whitespace-nowrap">
                      {item.tag}
                    </span>
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed">
                    {item.content}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}